<form class="bootstrap-validation-background--hidden" [formGroup]="form">
  <!-- username -->
  <!-- <div class="form-group">
    <label class="form-label" for="username">{{ 'login.username' | translate }}</label>
    <input
      #username
      [portalAutofocus]="true"
      [skipValidationIfPristine]="true"
      autocomplete="username"
      class="form-control"
      formControlName="username"
      id="username"
      portalInputValidityState
      type="text"
    />
    <portal-form-validation-errors
      [skipValidationIfPristine]="true"
      controlName="username"
    ></portal-form-validation-errors>
    @if (usernameIsChecked) {
      <button (click)="changeUsername()" class="btn btn--portal-link" type="button">
        {{ 'general.change' | translate }}
      </button>
    }
  </div> -->
  <div class="form-group">
    <label class="form-label" for="username">{{ 'login.username' | translate }}</label>
    <div class="input-group">
      <input
        class="form-control"
        id="username"
        #username
        [portalAutofocus]="true"
        [skipValidationIfPristine]="true"
        autocomplete="username"
        formControlName="username"
        portalInputValidityState
        type="text"
      />
      @if (usernameIsChecked) {
        <button class="form-control" (click)="changeUsername()" type="button">
          <i class="far fa-pencil"></i>
        </button>
      }
    </div>
    <portal-form-validation-errors
      [skipValidationIfPristine]="true"
      controlName="username"
    ></portal-form-validation-errors>
  </div>
  <!-- <small class="form-text text-muted" id="usernameHelp">
    {{ 'login.username.info' | translate }}
  </small> -->

  <!-- password -->
  <div class="form-group mb-4" [class]="{ 'hide-password-field': !usernameIsChecked }">
    <label class="form-label" for="password">{{ 'login.password' | translate }}</label>
    <portal-password-to-text>
      <input
        class="form-control"
        id="password"
        #passwordInput
        [skipValidationIfPristine]="true"
        autocomplete="current-password"
        formControlName="password"
        portalInputValidityState
        type="password"
      />
    </portal-password-to-text>

    <portal-form-validation-errors
      [skipValidationIfPristine]="true"
      controlName="password"
    ></portal-form-validation-errors>
  </div>

  <portal-error-alert [collapsible]="false" [dismissible]="false" [error]="error"></portal-error-alert>

  @if (usernameIsChecked) {
    <portal-save-button
      [disabledOnPristine]="false"
      [invalid]="form.invalid"
      [pristine]="form.pristine"
      [state]="loading"
      (save)="submit()"
    >
      <span>{{ 'login.button' | translate }}</span>
    </portal-save-button>
  } @else {
    <portal-save-button
      [disabledOnPristine]="false"
      [invalid]="form.invalid"
      [pristine]="form.pristine"
      [state]="loading"
      (save)="checkAuthMethodForUsername()"
    >
      <span>{{ 'login.checkAuthMethodForUsername.button' | translate }}</span>
    </portal-save-button>
  }

  @if (usernameIsChecked) {
    <a
      class="ms-2"
      [routerLink]="[
        '/forgot-password',
        form.getRawValue()?.username ? { u: form.getRawValue()?.username } : {},
      ]"
    >
      {{ 'login.forgotPassword' | portalTranslate }}
    </a>
  }
</form>
